import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;
export const RowItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const AreaInfo = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 40px;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.hoverGray};
  }

  > img {
    width: 100%;
    max-width: 80px;
    max-height: 80px;
    min-width: 80px;
    min-height: 80px;
    object-fit: contain;
  }
`;
export const NamePricePart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;
interface IAreaForm {
  $isThreeColumns?: boolean;
}
export const AreaForm = styled.div<IAreaForm>`
  display: grid;
  grid-template-columns: ${({ $isThreeColumns }) =>
    $isThreeColumns ? '1fr 1fr 1fr' : '1fr 1fr'};
  gap: 0.4rem;
`;

export const AreaPartTypeBrand = styled.div`
  display: flex;
  flex-direction: row;
`;

